import { useEffect, useState } from "react";
import useAppContext from "../hooks/useAppContext";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { bloqueoPegarCopiar, soloNumeros } from "../helpers/validaRut";
import { envioCorreo, getHtmlCorreo } from "../helpers/envioCorreo";
import Swal from "sweetalert2";
import { crearPDF, toBase64 } from "../helpers/crearPDF";
import { bitacoraTramite } from "../helpers/bitacoraApp";
import { formatearCantidad, formatNumber } from "../helpers/formateaRut";
import Spinner from "./Spinner";

const FormularioValeVista = () => {
  const {
    dataRegion,
    dataComuna,
    getDataComunas,
    infoPersona,
    montoTotalUsuario,
    getDataComprobante,
    cargando,
    calendario,
    setCargando,
  } = useAppContext();

  const [codigoRegion, setCodigoRegion] = useState("");
  const [modalConfirmar, setModalConfirmar] = useState("");
  const [validaModal, setValidaModal] = useState(true);

  useEffect(() => {}, [modalConfirmar]);

  const navigate = useNavigate();

  let fechaPeriodo = calendario.fechaInicio
    fechaPeriodo = new Date(fechaPeriodo)
          .toLocaleDateString('es-CL', { year:"numeric", month:"long", day:"numeric"}).slice(5).replace("de ", "").toString();
    fechaPeriodo = fechaPeriodo[1].toUpperCase() + fechaPeriodo.substring(2)

  useEffect(() => {
    if (codigoRegion) {
      getDataComunas(codigoRegion);
    }
  }, [codigoRegion]);

  return (
    <>
    {cargando && (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      )}
      <Formik
        initialValues={{
          email: "",
          confirmarEmail: "",
          telefono: "",
          direccion: "",
          comuna: "",
        }}
        validate={(valores) => {
          let errores = {};

          //VALIDAR EMAIL
          if (!valores.email) {
            errores.email = "Este campo es obligatorio";
          } else if (
            !/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(
              valores.email
            )
          ) {
            errores.email = "El correo ingesado no es válido";
          }

          //VALIDAR CONFIRMAR EMAIL
          if (!valores.confirmarEmail) {
            errores.confirmarEmail = "Este campo es obligatorio";
          } else if (
            !/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(
              valores.confirmarEmail
            )
          ) {
            errores.confirmarEmail = "El correo ingesado no es válido";
          } else if (valores.email !== valores.confirmarEmail) {
            errores.confirmarEmail =
              "El correo de confirmación debe ser igual al email de contacto";
          }

          //*VALIDAR TELEFONO
          if (!valores.telefono) {
            errores.telefono = "Este campo es obligatorio";
          } else if (!/^\d{7,10}$/.test(valores.telefono)) {
            errores.telefono = "El teléfono ingresado es incorrecto";
          }

          //VALIDAR DIRECCIÓN
          if (!valores.direccion || valores.direccion.length < 3) {
            errores.direccion =
              "El campo dirección es obligatorio y debe tener mínimo 3 caracteres";
          }

          //VALIDAD REGIÓN
          if (codigoRegion === "") {
            errores.codigoRegion = "Este campo es obligatorio";
          }

          //VALIDAR COMUNA
          if (valores.comuna === "") {
            errores.comuna = "Este campo es obligatorio";
          }

          if (Object.entries(errores).length === 0) {
            setValidaModal(false);
          }

          return errores;
        }}
        onSubmit={async (valores, { resetForm }) => {
          const requestBody = {
            rut: parseInt(infoPersona.run),
            direccion: valores.direccion,
            region: codigoRegion,
            comuna: valores.comuna,
            telefono: valores.telefono,
            email: valores.email,
            tipoPago: "Vale Vista",
            montoDevolucion: montoTotalUsuario,
            periodoDevolucion: infoPersona.periodoDPE,
          };

          Swal.fire({
            title:
              "Para finalizar este proceso debe confirmar datos de Devolución.",
            html: `Estimado: ${infoPersona.nombre} ${
              infoPersona.apellPater || ""
            } ${infoPersona.apellMater || ""} 
            <br> RUN-RUT: ${formatNumber(infoPersona.run)}-${infoPersona.dv} 
            <br> Total Devolución: <strong>${formatearCantidad(
              montoTotalUsuario
            )}</strong> 
            <br><br> Banco: Vale Vista Banco Scotiabank
            <br> Correo electrónico: ${valores.email}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#198754",
            cancelButtonColor: "#dc3545",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.isConfirmed) {
              const request = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestBody),
              };
              let objPDF = {};
              let objBitacora = {};
              const URL = `${process.env.REACT_APP_WS_DEP}/insertaceptada`;
              setCargando(true);
              objBitacora.fechaInicio = new Date();
              fetch(URL, request).then((data) => {
                data.json().then((resp) => {
                  let adjuntos = "";
                  if (resp.status === 500) {
                    navigate("/completadoproceso");
                    setCargando(false);
                  } else {
                    getDataComprobante(
                      parseInt(infoPersona.run),
                      infoPersona.periodoDPE
                    ).then((data) => {
                      objBitacora.data = data;
                      objPDF = {
                        data,
                        infoPersona,
                      };

                      //CREAR PDF
                      const blob = crearPDF(objPDF);
                      toBase64(blob).then((data) => {
                        adjuntos = data;
                        const requestCorreo = {
                          asunto:
                          `Comprobante FONASA DPE Masivo Proceso ${fechaPeriodo}`,
                          remitente: "NotificacionFonasa@fonasa.cl",
                          destinatarios: [valores.email],
                          destinatariosConCopia: [],
                          destinatariosConCopiaOculta: [],
                          adjuntos: ["ComprobanteDPE.pdf" + adjuntos],
                          mensaje: getHtmlCorreo(objPDF),
                        };

                        // *ENVIO DE CORREO
                        envioCorreo(requestCorreo);
                        // navigate("/propuesta/comprobantepropuesta");
                        localStorage.removeItem("run");
                        localStorage.removeItem("serieRun");
                      });
                      setCargando(false);
                      objBitacora.fechaFin = new Date();
                      bitacoraTramite(objBitacora);
                    });

                    Swal.fire({
                      icon: "success",
                      title:
                        "Estimado(a). Su solicitud de devolución de cotizaciones ha sido enviada con éxito al correo electrónico registrado. Presione Aceptar para ver resumen de devolución.",
                      confirmButtonColor: "#198754",
                      confirmButtonText: "Aceptar",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        navigate("/propuesta/comprobantepropuesta");
                      }
                    });
                  }
                });
              });
            }
          });
        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          handleChange,
          handleBlur,
        }) => (
          <form onSubmit={handleSubmit} autoComplete="new-password">
            <div className="form-group row mt-4">
              <label
                htmlFor="email"
                className="col-sm-3 col-form-label text-left"
              >
                <span className="text-danger">* </span> Correo Electrónico
              </label>
              <div className="col-sm-7">
                <input
                  className="form-control shadow-sm"
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="new-password"
                  placeholder="Ej.: correo@correo.com"
                  maxLength={40}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onPaste={bloqueoPegarCopiar}
                  onCut={bloqueoPegarCopiar}
                  onCopy={bloqueoPegarCopiar}
                />
                {touched.email && errors.email && (
                  <p className="text-danger mt-2">{errors.email}</p>
                )}
              </div>
            </div>

            <div className="form-group row mt-4">
              <label htmlFor="email" className="col-sm-3 col-form-label ">
                <span className="text-danger">* </span>Confirmar Correo
                Electrónico
              </label>
              <div className="col-sm-7">
                <input
                  className="form-control shadow-sm"
                  id="confirmarEmail"
                  name="confirmarEmail"
                  type="email"
                  autoComplete="new-password"
                  placeholder="Ej.: correo@correo.com"
                  maxLength={40}
                  value={values.confirmarEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onPaste={bloqueoPegarCopiar}
                  onCut={bloqueoPegarCopiar}
                  onCopy={bloqueoPegarCopiar}
                />
                {touched.confirmarEmail && errors.confirmarEmail && (
                  <p className="text-danger mt-2">{errors.confirmarEmail}</p>
                )}
              </div>
            </div>
            <div className="form-group row mt-4">
              <label htmlFor="telefono" className="col-sm-3 col-form-label ">
                <span className="text-danger">* </span>N° de Teléfono +56
              </label>
              <div className="col-sm-7">
                <input
                  className="form-control shadow-sm"
                  id="telefono"
                  name="telefono"
                  type="text"
                  maxLength="10"
                  minLength="9"
                  autoComplete="new-password"
                  placeholder="Ingrese el n° de teléfono sin puntos"
                  value={values.telefono}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onPaste={bloqueoPegarCopiar}
                  onCut={bloqueoPegarCopiar}
                  onCopy={bloqueoPegarCopiar}
                  onKeyDown={(e) => {
                    soloNumeros(e);
                  }}
                />
                {touched.telefono && errors.telefono && (
                  <p className="text-danger mt-2">{errors.telefono}</p>
                )}
              </div>
            </div>

            <div className="form-group row mt-4">
              <label htmlFor=".." className="col-sm-3 col-form-label ">
                <span className="text-danger">* </span> Región
              </label>
              <div className="col-sm-7">
                <select
                  className="form-select shadow-sm"
                  name="region"
                  onChange={(e) => {
                    setCodigoRegion(e.target.value);
                  }}
                >
                  <option>Seleccione Región</option>

                  {dataRegion.map((regiones) => {
                    return (
                      <option
                        key={regiones.codigoPrincipal}
                        value={regiones.codigoPrincipal}
                      >
                        {regiones.descripcion}
                      </option>
                    );
                  })}
                </select>
                {!codigoRegion && (
                  <p className="text-danger mt-2">{errors.codigoRegion}</p>
                )}
              </div>
            </div>
            <div className="form-group row mt-4">
              <label htmlFor=".." className="col-sm-3 col-form-label ">
                <span className="text-danger">* </span> Comuna
              </label>
              <div className="col-sm-7">
                <select
                  className="form-select shadow-sm"
                  name="comuna"
                  onChange={handleChange}
                >
                  <option>Seleccione Comuna</option>
                  {dataComuna.map((comunas) => {
                    return (
                      <option
                        key={comunas.codigoPrincipal}
                        value={comunas.codigoPrincipal}
                      >
                        {comunas.descripcion}
                      </option>
                    );
                  })}
                </select>
                {touched.comuna && errors.comuna && (
                  <p className="text-danger mt-2">{errors.comuna}</p>
                )}
              </div>
            </div>
            <div className="form-group row mt-4">
              <label htmlFor="direccion" className="col-sm-3 col-form-label ">
                <span className="text-danger">* </span> Dirección
              </label>
              <div className="col-sm-7">
                <input
                  className="form-control shadow-sm"
                  id="direccion"
                  name="direccion"
                  type="text"
                  maxLength="100"
                  autoComplete="new-password"
                  placeholder=""
                  value={values.direccion}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onPaste={bloqueoPegarCopiar}
                  onCut={bloqueoPegarCopiar}
                  onCopy={bloqueoPegarCopiar}
                />
                {touched.direccion && errors.direccion && (
                  <p className="text-danger mt-2">{errors.direccion}</p>
                )}
              </div>
            </div>
            <p className="text-danger pt-3">
              <strong>* Datos obligatorios</strong>
            </p>
            <p className="text-center mt-4">
              <button
                className="btn btn-primary shadow-sm"
                type="submit"
                disabled={validaModal ? true : false}
              >
                Solicitar Devolución
              </button>
            </p>
          </form>
        )}
      </Formik>
    </>
  );
};

export default FormularioValeVista;
